export const ECONOMIC_CALENDAR_PAGE_SLUG = 'economic-calendar';
